module.exports = "/public/images/c9d74e306cca0833dda1a8e8fe12c430.svg";